module.exports = __webpack_public_path__ + "static/img/logo2.9547711.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logo2.png
// module id = sJE0
// module chunks = 33